import { useQuery } from "react-query";
import apiService from "../../service/apiService";
import { useCookie } from "../useCookie";
import { apiConfig } from "../../config/apiConfig";

export type PlacePendingAmountResponse = {
  amount: number;
};

export const usePlacePendingAmount = (placeId?: string | null) => {
  const { token } = useCookie("vToken");

  const { data, isLoading, isFetching, refetch } = useQuery(
    ["placePendingAmount", placeId],
    () =>
      apiService.MakeGetRequest<PlacePendingAmountResponse>(
        apiConfig.payment.pendingAmount(placeId as string),
        token,
      ),
    {
      enabled: Boolean(placeId && token),
    },
  );

  return {
    pendingAmount: data?.amount ?? 0,
    isLoading,
    isFetching,
    refetch,
  };
};
